module.exports = __webpack_public_path__ + "static/media/3동물권-아주아주센모기약이발명된다면.3c1b84d5.mp3";